<section
  class="order-container"
  id="short-sell-order"
  *ngIf="isValidissueAndContractShortSale"
>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right">
        <div class="title-name">Precio</div>
      </div>
    </div>
    <div
      punchPicker
      [class]="'titulos'"
      [isTitles]="true"
      [placeholder]="'Títulos'"
      (items)="setTitles($event)"
      [sentValue]="titles"
      data-recording-ignore="mask"
    ></div>
    <div
      punchPicker
      [class]="'price'"
      [minValue]="minPrice"
      [placeholder]="'Precio'"
      [sentValue]="selectedPrice"
      [isPrice]="true"
      (items)="setPrice($event)"
      data-recording-ignore="mask"
    ></div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name disabled">Duración</div>
      </div>
    </div>
    <div class="hard-section">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div
    class="actions shortsale"
    *ngIf="canOperate && !isDiscretional && isGeolocationEnabled"
  >
    <button (click)="tryShortSale()" class="btn-shortsale">
      Vender en corto
    </button>
  </div>
</section>

<section id="short-sell-order" *ngIf="!isValidissueAndContractShortSale">
  <div *ngIf="!hasShortSellContract">
    <div class="outof-service">
      <div class="information-card">
        <div class="information-card__container">
          <div
            class="information-card__leading-icon information-card__leading-icon--info"
          ></div>
          <div class="information-card__information">
            <p>
              Este contrato no puede operar ventas en corto. <br />
              <span
                >Para habilitarlas u obtener más información, contacta a tu
                asesor o manda correo a
                <a class="link-blotter link-gbmplus" href="mailto:plus@gbm.com"
                  >plus@gbm.com.</a
                >
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isIssueAllowedShortSell && hasShortSellContract">
    <div class="outof-service">
      <div class="information-card">
        <div class="information-card__container">
          <div
            class="information-card__leading-icon information-card__leading-icon--info"
          ></div>
          <div class="information-card__information">
            <p>Esta emisora no puede operar ventas en corto.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="text-detail">
      <span
        >Consulta el módulo "Ventas en Corto" en la sección de Operación.</span
      >
    </div>
  </div>
</section>
<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
